import type { LinkProps } from 'next/link'
import * as Headless from '@headlessui/react'
import NextLink from 'next/link'
import { forwardRef } from 'react'

function LinkLayout(
  props: LinkProps & React.ComponentPropsWithoutRef<'a'>,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  return (
    <Headless.DataInteractive>
      <NextLink {...props} ref={ref} />
    </Headless.DataInteractive>
  )
}

export const Link = forwardRef(LinkLayout)
